import LeaseModel from '../../../../model/lease';
import Loading from './../misc/Loading';
import LeaseComponent from './Lease';
import dealerModel from '../../../../model/dealer';
import variantModel from '../../../../model/variant';
import update from 'immutability-helper';
import React from 'react';
import ValidationError from '../../../../model/error/ValidationError';
import withRouter from '/src/components/misc/withRouter';
import queryString from 'query-string';

const errorToMessage = (error) => {
  console.error(error);
  if (error instanceof ValidationError) {
    return 'Lease validerer ikke og kan dermed ikke publiseres. Sjekk at alle påkrevede felter er fylt ut med gyldige verdier og prøv igjen.';
  }

  return 'En ukjent feil inntraff ved behandling av lease og handlingen kunne dermed ikke fullføres.';
};

class LeaseContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lease: null,
      modified: false,
      working: false,
      error: null
    };

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.handleUnarchive = this.handleUnarchive.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.leaseid) {
      Promise.all([
        LeaseModel.getById(this.props.match.params.leaseid, 1),
        dealerModel.query('fields.groupTags', {
          'fields.groupTags[exists]': true
        })
      ]).then(([lease, dealerGroupTags]) => {
        document.title = `Admin - Lease - ${lease.name}`;
        let tags = dealerGroupTags.items.reduce((res, tag) => {
          res.push(...tag.fields.groupTags['nb-NO']);

          return res;
        }, []);
        console.log('lease: ', lease);
        // Keep unique, and sort
        tags = [...new Set(tags)].sort();
        this.setState({
          lease: lease,
          tags: tags
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else {
      //"?make=40gRCS9YR26cMgssuiK0G4&model=erp-model-zoe&variants=1jvKaGJVkyfi7ZAXOeQBDn"
      let promise;
      const query = queryString.parse(this.props.location.search);

      if (query && query.variant) {
        promise = variantModel.getById(query.variant, 2);
      }

      Promise.all([
        LeaseModel.createEmpty(),
        dealerModel.query('fields.groupTags', {
          'fields.groupTags[exists]': true
        }),
        promise
      ]).then(([lease, dealerGroupTags, variant]) => {
        document.title = `Admin - Lease - ${lease.name}`;
        let tags = dealerGroupTags.items.reduce((res, tag) => {
          res.push(...tag.fields.groupTags['nb-NO']);

          return res;
        }, []);

        console.log('variant: ', variant);

        if (variant) {
          lease.make = variant.model.make;
          lease.model = variant.model;
          lease.variant = variant;
        }

        // Keep unique, and sort
        tags = [...new Set(tags)].sort();
        this.setState({
          lease: lease,
          tags: tags
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handleSave() {
    this.setState({
      error: null,
      working: true,
      modified: false
    });

    const isCreate = !this.state.lease.id;

    LeaseModel.save(this.state.lease, 1).then((lease) => {
      this.setState({
        working: false,
        lease: lease
      });

      if (isCreate) {
        this.props.history.push(`/lease/${lease.id}`);
      }
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handlePublish() {
    this.setState({
      working: true
    });
    LeaseModel.publish(this.state.lease.id, 1).then((lease) => {
      this.setState({
        working: false,
        lease: lease
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnpublish() {
    this.setState({
      working: true
    });
    LeaseModel.unpublish(this.state.lease.id, 1).then((lease) => {
      this.setState({
        working: false,
        lease: lease
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleArchive() {
    this.setState({
      working: true
    });
    LeaseModel.archive(this.state.lease.id, 1).then((lease) => {
      this.setState({
        working: false,
        lease: lease
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnarchive() {
    this.setState({
      working: true
    });
    LeaseModel.unarchive(this.state.lease.id, 1).then((lease) => {
      this.setState({
        working: false,
        lease: lease
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleChange(props) {
    const state = update(props, {
      modified: {
        $set: true
      }
    });

    this.setState(state);
  }

  render() {
    if (!this.state.lease) {
      return <Loading title="Lease" text="Laster..." />;
    }

    return (
      <LeaseComponent
        lease={this.state.lease}
        tags={this.state.tags}
        modified={this.state.modified}
        working={this.state.working}
        error={this.state.error}
        onChange={this.handleChange}
        onSave={this.handleSave}
        onPublish={this.handlePublish}
        onUnpublish={this.handleUnpublish}
        onArchive={this.handleArchive}
        onUnarchive={this.handleUnarchive}
      />
    );
  }
}

LeaseContainer.defaultProps = {
  id: null
};

export default withRouter(LeaseContainer);
